module.exports = __webpack_public_path__ + "img/single.9741dac5.webp";